import { Flex, FlexProps } from '@cmpsr/components';
import { PropsWithChildren } from 'react';

export default function FormContainerAuthPages({ children, ...props }: PropsWithChildren<FlexProps>) {
  return (
    <Flex
      direction="column"
      backgroundColor="background-page"
      p={{ base: 'spacer-5', lg: 'spacer-10' }}
      borderRadius="radii-4"
      width="100%"
      gap={6}
      mb={4}
      {...props}
    >
      {children}
    </Flex>
  );
}
